import config from "@/config";
import http from "@/utils/request";

export default {
	white: {
		list: {
			url: `${config.API_URL}/course/courseWhiteUserList`,
			name: "获取白名单列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		save: {
			url: `${config.API_URL}/course/storeWhiteUser`,
			name: "新增白名单",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/course/delWhiteUser`,
			name: "删除白名单",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
};
